<template lang="pug">
  el-dialog(:title="!dataForm.id ? '新增' : '修改'", top='5vh', :close-on-click-modal='false', :visible.sync='visible' :append-to-body='true')
    el-form(:model='dataForm', :rules='dataRule', ref='dataForm', label-width='100px')
          el-form-item(label='主办方名称:', prop='name')
            el-input(v-model='dataForm.name', placeholder='请填写主办方名称' )
          el-form-item(label='地区:')
            el-select(v-model="dataForm.proviceId" placeholder="请选择",@change="changeProvice")
                el-option(v-for="(item,index) in proviceList",:key="index",:label="item.name",:value="item.proviceId")
            font &nbsp;&nbsp; 省 &nbsp;&nbsp;
            el-select(v-model="dataForm.cityId",placeholder="请选择")
                el-option(v-for="(item,index) in cityList",:key="index",:label="item.cityname",:value="item.cityId")
            font &nbsp;&nbsp; 市 &nbsp;&nbsp;
          el-form-item(label='赛事类型:', prop='byx1')
            el-checkbox-group(v-model="ctType" @change="changeCtType")
                el-checkbox(v-for="(item,index) in ctTypeList" :label="item.label" :key="item.key" )
          el-form-item(label='开户名:', prop='accountName')
            el-input(v-model='dataForm.accountName', maxlength='100', placeholder='请填写开户名', clearable)
          el-form-item(label='开户行:', prop='accountBank')
            el-input(v-model='dataForm.accountBank', maxlength='100', placeholder='请填写开户行', clearable)
          el-form-item(label='账号:', prop='accountNo')
            el-input(v-model='dataForm.accountNo', maxlength='100', placeholder='请填写账号', clearable)
          el-form-item(label='税号:', prop='taxId')
            el-input(v-model='dataForm.taxId', maxlength='100', placeholder='请填写税号', clearable)
          el-form-item(label='地址:', prop='accountAddress')
            el-input(v-model='dataForm.accountAddress', maxlength='100', placeholder='请填写地址', clearable)
          el-form-item(label='联系人:', prop='contactName')
            el-input(v-model='dataForm.contactName', maxlength='100', placeholder='请填写联系人', clearable)
          el-form-item(label='联系电话:', prop='contactPhone')
            el-input(v-model='dataForm.contactPhone', maxlength='100', placeholder='请填写联系电话', clearable)
          el-form-item(label='主办方简介:', prop='remark')
            el-input(type="textarea" :rows="2" resize="none" v-model="dataForm.remark" )
    span.dialog-footer(slot='footer')
      el-button(@click='visible = false') 取消
      el-button(type='primary', @click='dataFormSubmit()' :disabled="clickFlag") 确定
</template>

<script>

const validatorFn = (rule, value, callback) => {
  if (value === '') {
    callback()
  } else if (!/^[A-Za-z0-9\u4e00-\u9fa5]+$/.test(value)) {
    callback(new Error('仅支持英文字母、中文字符和数字'))
  } else {
    callback()
  }
}

export default {
  data () {
    return {
      visible: false,
      proviceList: [],
      cityList: [],
      dataForm: {
        id: 0,
        name: '',
        proviceId: '',
        cityId: '',
        byx1: [],
        accountName: '',
        accountBank: '',
        accountNo: '',
        taxId: '',
        accountAddress: '',
        contactName: '',
        contactPhone: '',
        remark: ''
      },
      ctTypeList: [
        { key: '1', label: '常规赛' },
        { key: '2', label: '月度赛' },
        { key: '3', label: '季度赛' },
        { key: '4', label: '年度总决赛' }
      ],
      ctType: [],
      clickFlag: false,
      dataRule: {
        name: [
          { required: true, message: '主办方名称不能为空！', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
         byx1: [
          { required: true, message: '赛事类型不能为空！', trigger: 'blur' }
        ],
        // accountName: [
        //   { validator: validatorFn, trigger: 'blur' }
        // ],
        // accountBank: [
        //   { validator: validatorFn, trigger: 'blur' }
        // ],
        // accountNo: [
        //   { validator: validatorFn, trigger: 'blur' }
        // ],
        // taxId: [
        //   { validator: validatorFn, trigger: 'blur' }
        // ],
        // accountAddress: [
        //   { validator: validatorFn, trigger: 'blur' }
        // ],
        remark: [
          { min: 1, max: 500, message: '长度在 1 到 500 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init (id) {
        this.clickFlag = false
      this.dataForm.id = id || 0
      this.proviceList = []
      this.ctType = []
      this.cityList = []
      this.dataForm.proviceId = ''
      this.dataForm.cityId = ''
      this.$http({
        url: this.$http.adornUrl('/dicProvince/list'),
        method: 'get',
        params: this.$http.adornParams()
      }).then((data) => {
        console.log(data)
        this.proviceList = data && data.code === 0 ? data.list : []
        console.log(this.proviceList)
      }).then(() => {
        this.visible = true
        this.dataForm.proviceId = ''
          this.dataForm.cityId = ''
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
        })
      }).then(() => {
        if (this.dataForm.id) {
          this.$http({
            url: this.$http.adornUrl(`/sysOrg/getId/${this.dataForm.id}`),
            method: 'get',
            params: this.$http.adornParams()
          }).then((data) => {
            if (data && data.code === 0) {
              this.dataForm.name = data.bean.name
              this.dataForm.proviceId = data.bean.province
              this.dataForm.cityId = data.bean.city
              this.dataForm.byx1 = data.bean.byx1.split(',')
              this.dataForm.accountName = data.bean.accountName || ''
              this.dataForm.accountBank = data.bean.accountBank || ''
              this.dataForm.accountNo = data.bean.accountNo || ''
              this.dataForm.taxId = data.bean.taxId || ''
              this.dataForm.accountAddress = data.bean.accountAddress || ''
              this.dataForm.contactName = data.bean.contactName || ''
              this.dataForm.contactPhone = data.bean.contactPhone || ''
              this.dataForm.remark = data.bean.remark
              this.ctType = []
              this.dataForm.byx1.forEach(e => {
                this.ctTypeList.forEach(c => {
                  if (e === c.key) {
                   this.ctType.push(c.label)
                  }
                })
              })
          }
              this.changeProvice(0)
          })
        }
      })
    },
    changeProvice (flag) {
      if (flag != 0) {
        this.cityList = []
        this.dataForm.cityId = ''
      }
          this.$http({
            url: this.$http.adornUrl('/dicProvinceCity/list'),
            method: 'get',
            params: this.$http.adornParams({
                'proviceId': this.dataForm.proviceId
        })
          }).then((data) => {
            this.cityList = data && data.code === 0 ? data.list : []
          })
    },
    // 表单提交
    dataFormSubmit () {
      this.$refs['dataForm'].validate((valid) => {
          this.dataForm.byx1 = this.dataForm.byx1.join(',')
        if (valid) {
            this.clickFlag = true
          this.$http({
            url: this.$http.adornUrl(`/sysOrg/${!this.dataForm.id ? 'save' : 'update'}`),
            method: 'post',
            data: {
              'id': this.dataForm.id || undefined,
              'name': this.dataForm.name,
              'province': this.dataForm.proviceId,
              'city': this.dataForm.cityId,
              'byx1': this.dataForm.byx1,
              'accountName': this.dataForm.accountName || '',
              'accountBank': this.dataForm.accountBank || '',
              'accountNo': this.dataForm.accountNo || '',
              'taxId': this.dataForm.taxId || '',
              'accountAddress': this.dataForm.accountAddress || '',
              'contactName': this.dataForm.contactName || '',
              'contactPhone': this.dataForm.contactPhone || '',
              'remark': this.dataForm.remark
            }
          }).then((data) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.visible = false
                  this.$emit('refreshdatalist')
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    },
    changeCtType (value) {
      this.dataForm.byx1 = []
      value.forEach(e => {
        this.ctTypeList.forEach(c => {
          if (e === c.label) {
            this.dataForm.byx1.push(c.key)
          }
        })
      })
    }
   }
 }
</script>
